import React, { useContext } from "react";
import { Route } from "react-router-dom";

import { AppConfigContext } from "../configuration/Configuration";
import { SprintAccessRight } from "../security/SprintAccessRight";
import { User } from "../security/User";
import { UserContext } from "../security/UserProvider";
import { Environment, environmentResolver } from "../types/Environment";

export interface RouteItem {
    path: string;
    component: React.ComponentType;
    accessRights: SprintAccessRight[];
    excludedForEnvironments?: Environment[];
    name: string;
}

const isAuthorized = (user: User, requiredAccessRights: SprintAccessRight[]): boolean => {
    if (!requiredAccessRights) return true;

    return requiredAccessRights.some((role: SprintAccessRight) => user.accessRights.includes(role));
};

const isHiddenForEnv = (resolvedEnvironment: Environment, environmentsToHide?: Environment[]) => {
    if (!environmentsToHide) {
        return false;
    }

    return environmentsToHide.includes(resolvedEnvironment);
};

interface ProtectedRouteProps {
    protectedRouteData: RouteItem;
}

export const ProtectedRoute: React.FunctionComponent<ProtectedRouteProps> = (props: ProtectedRouteProps) => {
    const userContext = useContext(UserContext);
    const { environment } = useContext(AppConfigContext);

    const protectedRouteData: RouteItem = props.protectedRouteData;
    const resolvedEnvironment = environmentResolver(environment);

    return (
        <>
            {isAuthorized(userContext, protectedRouteData.accessRights) &&
                !isHiddenForEnv(resolvedEnvironment, props.protectedRouteData.excludedForEnvironments) && (
                    <Route path={protectedRouteData.path} exact={true} component={protectedRouteData.component} />
                )}
        </>
    );
};
